module.exports = __webpack_public_path__ + "MediumIllustrationHouse@1x-3VElwil.png";